// Header.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import appStoreImg from "../assets/img/app-store.png";
import googlePlayImg from "../assets/img/google.store.png";
import { trackAppStoreClick, trackCoachCtaClick, trackGooglePlayClick } from "../analytics/googleAnalytics";

const DOWNLOAD_HEADER_URL = "https://wayoai.app/download?utm_source=website&utm_medium=button&utm_campaign=header_mobile";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${scrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        
        {/* Logo */}
        <Link to="/" className="logo-link">
          <img 
            src="/assets/img/wayo-logo.webp" 
            alt="Wayo" 
            className="logo"
          />
        </Link>
        
        {/* Desktop menu */}
        <nav className="desktop-menu">
          <Link
            to="/coaches"
            className="nav-link nav-link-coach"
            onClick={() => trackCoachCtaClick("header_para_coaches_desktop")}
          >
            Para Coaches
          </Link>
          <Link to="/#planes" className="nav-link">Alimentación</Link>
          <Link to="/#workouts" className="nav-link">Entrenamientos</Link>
          <Link to="/blog" className="nav-link">Blog</Link>
          <Link to="/embajadores" className="nav-link">Embajadores</Link>
          <Link to="/contador-calorias" className="nav-link nav-link-highlight">Calculadora</Link>
          <Link to="/premium" className="nav-link nav-link-premium">Hazte Premium</Link>
        </nav>
        
        {/* Store buttons only - right side */}
        <div className="header-actions">
          <div className="store-buttons">
            <a
              href="https://apps.apple.com/app/id6756500478"
              className="store-icon"
              aria-label="App Store"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackAppStoreClick("header_desktop")}
            >
              <img src={appStoreImg} alt="App Store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
              className="store-icon"
              aria-label="Google Play"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackGooglePlayClick("header_desktop")}
            >
              <img src={googlePlayImg} alt="Google Play" />
            </a>
          </div>
        </div>

        <a
          href={DOWNLOAD_HEADER_URL}
          className="header-mobile-download"
        >
          7 días gratis
        </a>
        
        {/* Burger menu */}
        <button 
          className={`burger-btn ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`mobile-menu ${menuOpen ? 'active' : ''}`}>
        <nav className="mobile-nav">
          <Link
            to="/coaches"
            onClick={() => {
              trackCoachCtaClick("header_para_coaches_mobile");
              setMenuOpen(false);
            }}
            className="mobile-nav-coach"
          >
            Para Coaches
          </Link>
          <Link to="/embajadores" onClick={() => setMenuOpen(false)}>Embajadores</Link>
          <Link to="/#planes" onClick={() => setMenuOpen(false)}>Alimentación</Link>
          <Link to="/#workouts" onClick={() => setMenuOpen(false)}>Entrenamientos</Link>
          <Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link>
          <Link to="/contador-calorias" onClick={() => setMenuOpen(false)}>Calculadora</Link>
          <Link to="/premium" onClick={() => setMenuOpen(false)} className="mobile-nav-premium">Hazte Premium</Link>
        </nav>
        
        <div className="mobile-stores">
          <a
            href="https://apps.apple.com/app/id6756500478"
            className="mobile-store-badge"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackAppStoreClick("header_mobile")}
          >
            <img src={appStoreImg} alt="App Store" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.facundosolis.wayo"
            className="mobile-store-badge"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackGooglePlayClick("header_mobile")}
          >
            <img src={googlePlayImg} alt="Google Play" />
          </a>
        </div>
      </div>
    </header>
  );
}
